/**
 * runtimeCaptureScope.ts — Round J A1 fix (2026-07-14 cross-thread hijack).
 *
 * The awaiting-input loop and the stuck-workflow recovery loop in
 * useGlobalTools iterate EVERY tool runtime. Before this fix they were not
 * thread-scoped, so a send on thread B could be captured by thread A's
 * awaiting-input runtime: `runtime.resume(...)` returned `handled=true`
 * BEFORE any spinner/stream existed on B — a totally silent send on B and a
 * ghost answer on A. This predicate is the single capture rule for both
 * loops (the orchestrator-entry gate got the equivalent treatment on
 * 2026-06-29 — see hasRunningWorkflow).
 *
 * Rules:
 *  - A runtime BOUND to a thread may only capture sends originating from
 *    that same thread.
 *  - An UNBOUND runtime (no recorded binding — legacy/single-thread mode)
 *    may only capture sends that also have no thread context. A thread-keyed
 *    send is never handed to a runtime whose home thread cannot be derived.
 */
export function canRuntimeCaptureSend(
  runtimeBoundThreadId: string | null | undefined,
  turnOriginatingThreadId: string | null,
): boolean {
  const bound = runtimeBoundThreadId ?? null;
  if (bound !== null) {
    return bound === turnOriginatingThreadId;
  }
  return turnOriginatingThreadId === null;
}
